import { shouldShowAddToBasketButton as jldsShouldShowAddToBasketButton } from '@JohnLewisPartnership/jl-design-system/components/product-card/cta-button/displayLogic';

export const shouldShowAddToBasketButton = (
  product = {},
  atbBlockList = []
) => {
  const { isMultiSku, defaultSkuId } = product;

  if (
    !jldsShouldShowAddToBasketButton(product, true) ||
    isMultiSku ||
    atbBlockList.includes(defaultSkuId)
  ) {
    return false;
  }

  return true;
};
